import { axiosClient } from '../axios';

export default async function getVerbalRoiContacts(clientId) {
  return axiosClient.get(`verbalroi/${clientId}`, { withCredentials: true });
}
